"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationContext = void 0;
const react_1 = require("react");
exports.TranslationContext = (0, react_1.createContext)({
    locale: '',
    availableLocales: [],
    setLocale: () => {
        // tslint:disable-next-line:no-console
        console.warn('TranslationContext has not been initialized');
    }
});
